/* eslint-disable react-hooks/rules-of-hooks */
import { useQuery } from "react-query";
import { CurrentUser, LoginResponse } from "../types/auth";
import { BaseResponse, LoginUserFormValues } from "../types/utils";
import { AUTH_URL } from "../utils/constants";
import { requestSimple, requestWithToken } from "../utils/functions";

export const loginUser = async (
  values: LoginUserFormValues
): Promise<BaseResponse<LoginResponse>> => {
  const response = await requestSimple(`${AUTH_URL}/auth/login`, "POST", values);

  return response?.data;
};

export async function registerUser(payload: any) {
  const response = await requestSimple(`${AUTH_URL}/auth/v2/register`, "POST", payload);

  return response?.data;
}

export async function submitChangePassword(payload: any) {
  const response = await requestWithToken(`${AUTH_URL}/auth/v2/change_password`, "POST", payload);

  return response?.data;
}

export async function submitChangeMultiFactor(payload: any) {
  const response = await requestWithToken(`${AUTH_URL}/auth/v2/update_mfa`, "POST", payload);

  return response?.data;
}

export function getUserInfo() {
  return useQuery("account.info", async () => {
    const response = await requestWithToken(`${AUTH_URL}/auth/v2/user_info`)

    return response?.data?.data?.user as CurrentUser
  }, {
    refetchOnWindowFocus: true,
    keepPreviousData: false,
    retry: false,
    staleTime: 5 * 60 * 1000,
    enabled: !!localStorage.getItem('SA')
  })
}

export async function resolveVerification(email: string) {
  try {
    const response = await requestSimple(`${AUTH_URL}/auth/v2/verification`, 'POST', {
      email
    })

    return response?.data
  } catch (exception) {
    return false
  }
}

export async function verificationValidation(payload: any) {
  const response = await requestSimple(`${AUTH_URL}/auth/v2/verification/validate`, 'POST', payload)

  return response?.data
}